import BeaconAdapter from './beacon-adapter';
import KissmetricsAdapter from './kissmetrics-adapter';

export enum TrackerType {
  Beacon,
  Kissmetrics
}

export interface TrackerConfig {
  retryLimit?: number;
}

export interface TrackerEvent {
  [key: string]: string | number | undefined | null;
  name: string;
}

export interface TrackerInstance {
  report: (event: TrackerEvent) => void;
}

export class TrackerFactory {
  public static create(
    type: TrackerType,
    config?: TrackerConfig
  ): TrackerInstance {
    switch (type) {
      case TrackerType.Beacon:
        return new BeaconAdapter(config);
      case TrackerType.Kissmetrics:
        return new KissmetricsAdapter(config);
    }
  }
}
